// src/components/landing/FooterSection.jsx
import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import bssLogo from '../../assets/images/bsslogo.jpeg';

const COLS = [
  { title: 'Programs', links: ['DCA', 'MS Office', 'Web Design', 'Tally', 'Hardware & Networking'] },
  { title: 'Company', links: ['About Us', 'Affiliations', 'Franchise', 'Gallery'] },
  { title: 'Support', links: ['Find a Center', 'Enroll Now', 'Student Login', 'Contact Us'] },
];

const SocialIcon = ({ children }) => (
  <Box sx={{ width: 34, height: 34, bgcolor: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', '&:hover': { bgcolor: 'rgba(56,189,248,0.1)', borderColor: 'rgba(56,189,248,0.2)' }, transition: 'all 0.2s' }}>
    {children}
  </Box>
);

export default function FooterSection() {
  return (
    <Box sx={{ bgcolor: '#05080f', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
      <Box sx={{ px: { xs: 3, md: 8 }, pt: 7, pb: 4 }}>
        <Grid container spacing={5} sx={{ mb: 5 }}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
              <Box component="img" src={bssLogo} alt="BSS IT Mission" sx={{ height: 36, width: 36, objectFit: 'contain', borderRadius: 1.5 }} />
              <Typography sx={{ fontWeight: 800, fontSize: '1rem', color: '#fff' }}>
                BSS IT <Box component="span" sx={{ color: '#38bdf8' }}>MISSION</Box>
              </Typography>
            </Box>
            <Typography sx={{ color: 'rgba(255,255,255,0.3)', fontSize: '0.82rem', lineHeight: 1.75, maxWidth: 260 }}>
              The IT Division of Bharat Sevak Samaj. Bringing government-recognized computer education to every corner of Kerala.
            </Typography>
          </Grid>
          {COLS.map((col) => (
            <Grid item xs={6} md={2.67} key={col.title}>
              <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase', color: 'rgba(255,255,255,0.35)', mb: 2 }}>
                {col.title}
              </Typography>
              {col.links.map((l) => (
                <Typography key={l} component="a" href="#" sx={{ display: 'block', fontSize: '0.82rem', color: 'rgba(255,255,255,0.35)', textDecoration: 'none', mb: 1.25, '&:hover': { color: '#38bdf8' }, transition: 'color 0.2s' }}>
                  {l}
                </Typography>
              ))}
            </Grid>
          ))}
        </Grid>

        <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.05)', pt: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <Typography sx={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.25)' }}>
            © 2025 BSS IT Mission. All rights reserved.
          </Typography>
          <Box sx={{ display: 'flex', gap: 1.25 }}>
            <SocialIcon>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="2"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
            </SocialIcon>
            <SocialIcon>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="2"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
            </SocialIcon>
            <SocialIcon>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="2"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/></svg>
            </SocialIcon>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
